export const appReadyEvent = 'AppEvent.ready';
export const signoutEvent = 'AppEvent.signout';
export const doSignoutEvent = 'AppEvent.doSignout';
export const beforeTimeoutEvent = 'AppEvent.beforeTimeout';
export const appUpdatedEvent = 'AppEvent.updated';
